var App = App || {};

App.TabSection = (function ($) {
    'use strict';

    var $desktopTabs, $mobileTabs;
    var isDesktop;
    let bpThreshold = 992; //threshold between md & lg bootstrap breakpoints

    function init() {
        //TabSection component duplicates content, thus duplicating the ids of any coponents within (bad)
        $desktopTabs = $(".tabsection-bottom-accordion");
        $mobileTabs = $('.tabsection-bottom-bottommobile');
        if ($(window).width() >= bpThreshold) {
            isDesktop = true;
        } else {
            isDesktop = false;
        }

        //find elements within tab panels which have ids, add the id as data for safekeeping
        //remove the id attr from the inactive breakpoint
        $desktopTabs.find("*").each(function () {
            if ($(this).attr("id")) {
                $(this).attr("data-tab-id", $(this).attr("id"));
                if ($(window).width() < bpThreshold) {
                    $(this).removeAttr('id');
                }
            }

        });
        $mobileTabs.find("*").each(function () {
            if ($(this).attr('id')) {
                $(this).attr("data-tab-id", $(this).attr('id'));
                if ($(window).width() >= bpThreshold) {
                    $(this).removeAttr('id');
                }
            }

        });

        //when window width crosses breakpoint threshold, add ids in active panel & remove from inactive
        $(window).resize(function () {
            if ($(window).width() >= bpThreshold && isDesktop == false) {
                setIdsWithin($desktopTabs);
                removeIdsWithin($mobileTabs);
                isDesktop = true;
            }
            if ($(window).width() < bpThreshold && isDesktop == true) {
                setIdsWithin($mobileTabs);
                removeIdsWithin($desktopTabs);
                isDesktop = false;
            }
        });
    }

    function setIdsWithin(elem) {
        elem.find("*").each(function () {
            if ($(this).attr("data-tab-id")) {
                $(this).attr("id", $(this).attr("data-tab-id"));
            }
        });
    }
    function removeIdsWithin(elem) {
        elem.find("*").each(function () {
            if ($(this).attr('id')) {
                $(this).removeAttr('id');
            }
        });
    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.TabSection.init();
});